import {Button, Alert, IconButton, Stack} from '@mui/material';
import { useEffect, useState } from 'react';
import API from '../../../services/API';
import { Link, useNavigate } from 'react-router-dom';
import Layout from "../../Frames/Layout"
import Loader from '../../Tools/Loader';
import { Delete, Edit } from '@mui/icons-material';
import Grid from "../../Tools/Grid";
import moment from 'moment';

export default function List(){

    const navigate = useNavigate()

    const [items, setItems] = useState(null)

    const [status, setStatus] = useState('loading')
    const statusIs = str => str === status

    const columns = [
        {
            field: 'title',
            headerName: 'Désignation',
            width: 400,
            valueGetter: p => p.row.title
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 120,
            valueGetter: p => p.row.type?.title
        },
        {
            field: 'variant',
            headerName: 'Variant',
            width: 150,
            valueGetter: p => p.row.variant?.title
        },
        {
            field: 'value',
            headerName: 'Prix (€)',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.price,
        },
        {
            field: 'reference',
            headerName: 'Référence 1',
            width: 160,
            valueGetter: p => p.row.reference,
        },
        {
            field: 'reference2',
            headerName: 'Référence 2',
            width: 150,
            valueGetter: p => p.row.reference2
        },
        {
            field: 'category',
            headerName: 'Filière',
            width: 120,
            valueGetter: p => p.row.category?.title || 'Toutes',
        },
        {
            field: 'duration',
            headerName: 'Durée (h)',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.hours,
        },
        {
            field: 'updatedAt',
            headerName: 'Modifié le',
            width: 100,
            type: 'date',
            valueGetter: p => moment(p.row.updatedAt).toDate(),
            renderCell: p => moment(p.row.updatedAt).format('DD/MM/YYYY')
        },
        {
            field: 'actions',
            headerName: '',
            width: 120,
            valueGetter: p => p.row.id,
            renderCell: p => 
                <Stack direction='row' spacing={1}>
                    <Link to={`/admin/products/${p.value}`}>
                        <IconButton size='small'>
                            <Edit />
                        </IconButton>
                    </Link>
                    <IconButton size='small' onClick={() => handleDelete(p.value)}>
                        <Delete />
                    </IconButton>
                </Stack> 
        },
    ]

    useEffect(() => {

        API.get('/products')
            .then(r => {
                setStatus('ready')
                setItems(r.data)
            })
            .catch(e => setStatus('error'))

    }, [])


    const handleDelete = id => {
        
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer ce produit ?")
        if(!ok) return false;

        let copy = [...items];
        copy = copy.filter(i => i.id !== id);

        API.delete(`/products/${id}`)
            .then(r => console.log(r.data))
            .catch(e => setItems([...items]))

        return setItems(copy);
    }


    return <Layout title="Tous les produits" tab="products" menu="admin" back={true}>


        <Button  
            variant='contained' 
            onClick={() => navigate('/admin/products/new')}
            sx={{mb: 1}}
        >
            Ajouter
        </Button>

        <Grid 
            id='productsGrid'
            columns={columns}
            rows={items}
            toolbar
        />

        
        {statusIs('error') && 
            <Alert severity="error">Une erreur s'est produite.</Alert>
        }

        {statusIs('loader') && 
            <Loader />
        }

    </Layout>
}

